<template>
  <b-container>
    <b-card no-body class="mt-3">
      <b-tabs card v-model="tabIndex">
        <b-tab title="Questions">
          <div v-if="getModules.length>0">
            <b-table responsive striped hover :items="getModules" :fields="modFields">
              <template v-slot:cell(#)="data">{{data.index + 1}}</template>
              <template v-slot:cell(module_name)="data">{{data.item.name}}</template>
              <template v-slot:cell(language)="data">{{data.item.language}}</template>
              <template v-slot:cell(action)="data">
                <b-button
                  size="sm"
                  variant="primary"
                  @click="setQuestions(data.item)"
                >Show Questions</b-button>
              </template>
            </b-table>
          </div>
        </b-tab>
        <b-tab title="Add New Question">
          <div>
            <b-form>
              <b-form-group id="input-group-1" label="Enter question:" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="questionText"
                  type="text"
                  required
                  placeholder="Enter Question here..."
                ></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-3" label="Question Type:" label-for="input-3">
                <b-form-select v-model="questionType">
                  <option
                    v-for="(questionType, ind ) in questionTypes"
                    :key="ind"
                    :value="questionType.name"
                  >{{ questionType.name}}</option>
                </b-form-select>
              </b-form-group>

              <b-form-group id="input-group-3" label="Module Name:" label-for="input-3">
                <b-form-select v-model="selectedModule">
                  <option v-for="(mod, ind ) in getModules" :key="ind" :value="mod">{{ mod.name }}</option>
                </b-form-select>
              </b-form-group>

              <b-button @click="addOrUpdateQuestion" variant="primary">Add Question</b-button>
            </b-form>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-card class="mt-3">
      <b-table responsive head-variant="none" :items="questions" :fields="fields">
        <template v-slot:cell(#)="data">{{data.index + 1}}</template>
        <template v-slot:cell(question)="data">{{data.item.question}}</template>
        <template v-slot:cell(action)="data">
          <b-button size="sm" variant="info" class="mr-2" @click="editQuestion(data.item)">Edit</b-button>
        </template>
      </b-table>
    </b-card>
  </b-container>
</template>

<script>
import { db } from "../../db";
export default {
  data() {
    return {
      tabIndex: 0,
      fields: [
        { key: "#", sortable: false },
        { key: "question", sortable: false },
        { key: "action", sortable: false }
      ],
      modFields: [
        { key: "#", sortable: false },
        { key: "module_name", sortable: false },
        { key: "language", sortable: true },
        { key: "action", sortable: false }
      ],
      modules: [],
      questionTypes: [
        { id: 1, name: "Single Choice" },
        { id: 2, name: "Multiple Choice" },
        { id: 3, name: "Yes No" }
      ],
      questionType: null,
      selectedModule: null,
      questionText: "",
      updateOperation: false,
      questionId: "",
      questions: []
    };
  },

  computed: {
    getModules() {
      return this.$store.getters.getModules;
    },
    getQuestions() {
      return this.$store.getters.getQuestions;
    }
  },

  created() {
    if (this.$store.getters.getModules.length == 0) {
      this.$store.dispatch("setModules");
    }
    if (this.$store.getters.getQuestions.length == 0) {
      this.$store.dispatch("setQuestions");
    }
  },
  methods: {
    setQuestions(data) {
      this.questions = [];
      this.questions = this.getQuestions.filter(el => {
        return el.moduleId == data.id;
      });
    },
    addOrUpdateQuestion() {
      if (
        this.questionText.trim() !== "" &&
        this.selectedModule.name.trim() !== ""
      ) {
        if (!this.updateOperation) {
          db.collection("questions").add({
            question: this.questionText,
            moduleId: this.selectedModule.id,
            questionType: this.questionType
          });
        } else {
          db.collection("questions")
            .doc(this.questionId)
            .update({
              question: this.questionText,
              moduleId: this.selectedModule.id,
              questionType: this.questionType.name
            });
        }
        this.$store.dispatch("setQuestions");
        this.resetValues();
      } else {
        alert("Please Enter Question Text and Select a Module ");
      }
    },
    editQuestion(value) {
      this.tabIndex = 1;
      this.questionText = value.questionText;
      this.selectedModule = this.getModules.find(mod => {
        return mod.id == value.moduleId;
      });
      var m = this.questionTypes.find(typ => {
        return typ.name == value.questionType;
      });
      this.questionType = m.name;
      this.updateOperation = true;
      this.questionId = value.id;
    },
    deleteModule() {
      alert("Currently Deleting Question is not working");
    },
    resetValues() {
      this.questionText = "";
      this.selectedModule = null;
      this.tabIndex = 0;
      this.updateOperation = false;
    }
  }
};
</script>